import * as moment from 'pkp-moment-timezone-all-years';

export class TimeHelperUtils {
    /** Special about this: It works beyond 2038 */
    public static isCentralEuropeanSummerTime(subjectDate: Date): boolean {
        if (subjectDate.getFullYear() < 2038) {
            return moment(subjectDate).isDST();
        }

        const fullYear = subjectDate.getFullYear();
        const january = new Date(fullYear, 0, 1);
        const july = new Date(fullYear, 6, 1);
        return (
            fullYear >= 2038 &&
            Math.min(january.getTimezoneOffset(), july.getTimezoneOffset()) ==
                subjectDate.getTimezoneOffset()
        );
    }
}
